import { render, staticRenderFns } from "./Voicelink.vue?vue&type=template&id=6e035d72"
import script from "./Voicelink.vue?vue&type=script&lang=js"
export * from "./Voicelink.vue?vue&type=script&lang=js"
import style0 from "./Voicelink.vue?vue&type=style&index=0&id=6e035d72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports